<template>
  <fragment>
    <mc-app-header title="Flows">
      <template #left>
        <div class="level-item">
          <router-link
            class="button is-small is-primary is-outlined"
            to="/flows/new"
          >
            Add New
          </router-link>
        </div>
      </template>
      <template #right>
        <div class="level-item">
          <flow-tag-select
            :value="flows.filters.tags"
            :multiple="false"
            @input="tagSelectHandler"
          />
        </div>
      </template>
    </mc-app-header>
    <mc-app-body>
      <div class="flows section">
        <mc-paginated-list resource-state="flows">
          <div v-if="flows.list.length === 0" class="box mc-container">
            <div class="content has-text-centered">
              No flows available!
            </div>
          </div>
          <div v-else class="mc-container">
            <div
              v-for="(flow, index) in flows.list"
              :key="index"
              class="flows__item box"
            >
              <div class="flows__item-details">
                <div
                  :class="[
                    'flows__item-title',
                    {
                      'flows__item-title--spacing':
                        flow.tags && flow.tags.length > 0
                    }
                  ]"
                >
                  {{ flow.id }}
                </div>
                <b-taglist v-if="flow.tags && flow.tags.length > 0">
                  <b-tag
                    v-for="(tag, tagIndex) in flow.tags"
                    :key="tagIndex"
                    type="is-info"
                  >
                    {{ tag }}
                  </b-tag>
                </b-taglist>
              </div>
              <router-link
                class="button is-link is-small"
                :to="`/flows/edit/${flow.id}`"
              >
                Edit
              </router-link>
            </div>
          </div>
        </mc-paginated-list>
      </div>
    </mc-app-body>
  </fragment>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import FlowTagSelect from './FlowTagSelect';

export default {
  computed: {
    ...mapState(['flows'])
  },
  methods: {
    ...mapActions('flows', ['setFilter']),
    tagSelectHandler(selected) {
      this.setFilter({ tags: selected ? selected.value : null });
    }
  },
  components: {
    FlowTagSelect
  }
};
</script>

<style lang="scss" scoped>
.flows {
  height: 100%;

  &__item {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1rem;
    margin-bottom: 0.5rem;
  }

  &__item-details {
    flex: 1 0 0;
    flex-direction: column;
    margin-right: 0.5rem;
  }

  &__item-title {
    &--spacing {
      margin-bottom: 0.5rem;
    }
  }
}
</style>
